import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  en: {
    // Navigation
    home: 'Home',
    dashboard: 'Dashboard',
    pricing: 'Pricing',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    createPost: 'Create Post',
    reviewReplies: 'Review Replies',
    profileAudit: 'Profile Audit',
    scheduledPosts: 'Scheduled Posts',
    upgradePlan: 'Upgrade Plan',
    signOut: 'Sign Out',
    
    // Hero
    heroTitle: 'Supercharge Your Google Business Profile',
    heroSubtitle: 'AI-powered tools to create engaging posts, respond to reviews, and optimize your local presence.',
    getStarted: 'Get Started Free',
    viewPricing: 'View Pricing',
    
    // Tools
    tools: 'Tools',
    postGenerator: 'GMB Post Generator',
    postGeneratorDesc: 'Create engaging Google Business Profile posts with AI',
    reviewReply: 'Review Reply Generator',
    reviewReplyDesc: 'Generate professional responses to customer reviews',
    auditTool: 'GMB Optimization Audit',
    auditToolDesc: 'Get a comprehensive audit of your business profile',
    
    // Forms
    businessType: 'Business Type',
    offer: 'Offer / Message',
    city: 'City',
    tone: 'Tone',
    language: 'Language',
    generate: 'Generate',
    generating: 'Generating...',
    professional: 'Professional',
    friendly: 'Friendly',
    promotional: 'Promotional',
    
    // Review
    customerReview: 'Customer Review',
    sentiment: 'Sentiment',
    positive: 'Positive',
    negative: 'Negative',
    neutral: 'Neutral',
    
    // Audit
    businessName: 'Business Name',
    category: 'Category',
    description: 'Description',
    runAudit: 'Run Audit',
    
    // Results
    generatedPosts: 'Generated Posts',
    generatedReplies: 'Generated Replies',
    auditResults: 'Audit Results',
    score: 'Score',
    issues: 'Issues',
    recommendations: 'Recommendations',
    copy: 'Copy',
    copied: 'Copied!',
    savePost: 'Save Post',
    schedulePost: 'Schedule Post',
    
    // Plans
    freePlan: 'Free',
    basicPlan: 'Basic',
    proPlan: 'Pro',
    perMonth: '/month',
    postsPerDay: 'posts per day',
    postsPerMonth: 'posts per month',
    unlimited: 'Unlimited',
    autoPosting: 'Auto Posting',
    manualOnly: 'Manual Only',
    currentPlan: 'Current Plan',
    upgrade: 'Upgrade',
    
    // Auth
    email: 'Email',
    password: 'Password',
    name: 'Full Name',
    confirmPassword: 'Confirm Password',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    
    // Dashboard
    welcomeBack: 'Welcome back',
    usageToday: 'Usage Today',
    usageMonth: 'Usage This Month',
    savedPosts: 'Saved Posts',
    savedReplies: 'Saved Replies',
    recentActivity: 'Recent Activity',
    
    // Misc
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
  },
  hi: {
    // Navigation
    home: 'होम',
    dashboard: 'डैशबोर्ड',
    pricing: 'मूल्य',
    login: 'लॉगिन',
    register: 'रजिस्टर',
    logout: 'लॉगआउट',
    createPost: 'पोस्ट बनाएं',
    reviewReplies: 'रिव्यू जवाब',
    profileAudit: 'प्रोफाइल ऑडिट',
    scheduledPosts: 'शेड्यूल पोस्ट',
    upgradePlan: 'प्लान अपग्रेड',
    signOut: 'साइन आउट',
    
    // Hero
    heroTitle: 'अपने Google Business Profile को सुपरचार्ज करें',
    heroSubtitle: 'आकर्षक पोस्ट बनाने, समीक्षाओं का जवाब देने और अपनी स्थानीय उपस्थिति को अनुकूलित करने के लिए AI-संचालित टूल।',
    getStarted: 'मुफ्त में शुरू करें',
    viewPricing: 'मूल्य देखें',
    
    // Tools
    tools: 'टूल्स',
    postGenerator: 'GMB पोस्ट जनरेटर',
    postGeneratorDesc: 'AI के साथ आकर्षक Google Business Profile पोस्ट बनाएं',
    reviewReply: 'रिव्यू रिप्लाई जनरेटर',
    reviewReplyDesc: 'ग्राहक समीक्षाओं के लिए पेशेवर प्रतिक्रियाएं उत्पन्न करें',
    auditTool: 'GMB ऑप्टिमाइजेशन ऑडिट',
    auditToolDesc: 'अपने बिजनेस प्रोफाइल का व्यापक ऑडिट प्राप्त करें',
    
    // Forms
    businessType: 'व्यवसाय का प्रकार',
    offer: 'ऑफर / संदेश',
    city: 'शहर',
    tone: 'टोन',
    language: 'भाषा',
    generate: 'जनरेट करें',
    generating: 'जनरेट हो रहा है...',
    professional: 'पेशेवर',
    friendly: 'मित्रवत',
    promotional: 'प्रचारात्मक',
    
    // Review
    customerReview: 'ग्राहक समीक्षा',
    sentiment: 'भावना',
    positive: 'सकारात्मक',
    negative: 'नकारात्मक',
    neutral: 'तटस्थ',
    
    // Audit
    businessName: 'व्यवसाय का नाम',
    category: 'श्रेणी',
    description: 'विवरण',
    runAudit: 'ऑडिट चलाएं',
    
    // Results
    generatedPosts: 'जनरेटेड पोस्ट',
    generatedReplies: 'जनरेटेड रिप्लाई',
    auditResults: 'ऑडिट परिणाम',
    score: 'स्कोर',
    issues: 'समस्याएं',
    recommendations: 'सिफारिशें',
    copy: 'कॉपी',
    copied: 'कॉपी किया!',
    savePost: 'पोस्ट सेव करें',
    schedulePost: 'पोस्ट शेड्यूल करें',
    
    // Plans
    freePlan: 'मुफ्त',
    basicPlan: 'बेसिक',
    proPlan: 'प्रो',
    perMonth: '/महीना',
    postsPerDay: 'पोस्ट प्रति दिन',
    postsPerMonth: 'पोस्ट प्रति माह',
    unlimited: 'असीमित',
    autoPosting: 'ऑटो पोस्टिंग',
    manualOnly: 'केवल मैनुअल',
    currentPlan: 'वर्तमान प्लान',
    upgrade: 'अपग्रेड',
    
    // Auth
    email: 'ईमेल',
    password: 'पासवर्ड',
    name: 'पूरा नाम',
    confirmPassword: 'पासवर्ड की पुष्टि करें',
    alreadyHaveAccount: 'पहले से खाता है?',
    dontHaveAccount: 'खाता नहीं है?',
    
    // Dashboard
    welcomeBack: 'वापसी पर स्वागत है',
    usageToday: 'आज का उपयोग',
    usageMonth: 'इस महीने का उपयोग',
    savedPosts: 'सेव किए गए पोस्ट',
    savedReplies: 'सेव किए गए रिप्लाई',
    recentActivity: 'हाल की गतिविधि',
    
    // Misc
    loading: 'लोड हो रहा है...',
    error: 'त्रुटि',
    success: 'सफल',
    cancel: 'रद्द करें',
    save: 'सेव करें',
    delete: 'हटाएं',
    high: 'उच्च',
    medium: 'मध्यम',
    low: 'कम',
  }
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('gmb_language') || 'en');

  useEffect(() => {
    localStorage.setItem('gmb_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en'][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'hi' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
